import firebase from 'firebase' 
var config = {
    apiKey: "AIzaSyC5vg3qT-mbmjP-JNCgCL5NUTzWGailBgk",
    authDomain: "conductive-ward-202120.firebaseapp.com",
    databaseURL: "https://conductive-ward-202120.firebaseio.com",
    projectId: "conductive-ward-202120",
    storageBucket: "conductive-ward-202120.appspot.com",
    messagingSenderId: "128582188465"
  };
const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({timestampsInSnapshots: true})
export default firebaseApp;


// WEBPACK FOOTER //
// ./src/firebase/init.js